import React from 'react';
import { Link } from 'react-router-dom';
import BottomNav from '../components/BottomNav';

export default function Home() {

  return (
    <div className="h-screen max-h-screen bg-gray-800 flex flex-col overflow-hidden">
      {/* Logo Area - ~22% of screen height */}
      <div className="flex-[0_0_22vh] max-h-52 flex items-center justify-center">
        <img 
          src="/HHINL-Single-Dog-Tag_White Red.svg" 
          alt="HHI Logo" 
          className="h-full max-h-36 w-auto object-contain p-4"
        />
      </div>

      {/* Main Content Area */}
      <div className="flex-1 min-h-0 flex flex-col items-center justify-start px-4 pt-8 pb-6 gap-12">
        <h1 className="text-3xl sm:text-4xl font-bold text-white text-center">
          30 Second Rule Timer
        </h1>

        <Link
          to="/timer"
          className="w-52 h-52 sm:w-64 sm:h-64 bg-red-600 rounded-full flex items-center justify-center shadow-2xl hover:shadow-3xl hover:bg-red-700 transform hover:scale-105 transition-all duration-300"
        >
          <span className="text-2xl sm:text-3xl font-bold text-white">
            Start Timer
          </span>
        </Link>
      </div>

      <BottomNav />
    </div>
  );
}
